exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-changes[data-v-3c1dee0c]{position:relative;background-color:#f0f0f0;height:100%}.list-changes-container[data-v-3c1dee0c]{padding-top:80px;width:90%}.btn-back[data-v-3c1dee0c]{position:absolute;top:20px;left:20px}", ""]);

// exports
